export function capitalize(value: string, locale?: Intl.LocalesArgument) {
	const slicedValue = split(value)

	if (slicedValue[0]) {
		slicedValue[0] = slicedValue[0].toLocaleUpperCase(locale)
	}

	return slicedValue.join('')
}

export function getInitials(value: string, count: number = 2) {
	return split(value).slice(0, count).join('')
}

export function stringIncludes(text: string, term: string): boolean {
	if (!term) {
		return true
	}

	const normalizedTerm = term.trim().toLowerCase()
	const normalizedText = text.trim().toLowerCase()

	if (normalizedText.includes(normalizedTerm)) {
		return true
	}

	return false
}

/**
 * Format plain text as HTML:
 * - `\n` to `<br>`
 * - `\n\n` to `<p>…</p>`
 */
export function formatPlainText(text: string) {
	const paragraphs = text.trim().split(/\n\n+/)

	return paragraphs
		.map((paragraph) => paragraph.split('\n').join('<br>'))
		.map((paragraph) => `<p>${paragraph}</p>`)
		.join('')
}

export function sanitizeRichText(text: string) {
	// Remove characters inserted by Fluent
	return text.replaceAll('\u2068', '').replaceAll('\u2069', '')
}

/**
 * Unicode-aware string splitting
 *
 * Normal splitting and slicing cuts through graphemes,
 * which can become an issue in languages that use a non-Latin alphabet.
 */
function split(value: string) {
	return [...value]
}
